export default __webpack_public_path__ + "static/media/11.b78d67fc.jpg";